import { useContext } from 'react';

import { SidePanelsContext } from './context';

export const useOpenMobileSideNavigation = (): [boolean, () => void] => {
  const { mobileSideNavigationOpen, toggleMobileSideNavigation } =
    useContext(SidePanelsContext);

  return [mobileSideNavigationOpen, toggleMobileSideNavigation];
};
